import { BoxProps, Heading } from '@chakra-ui/react';
import {
  IAddressSchema,
  IContactRespSchema,
  QuoteSettingsDefaultAddressSourceEnum,
} from '@monetize/types/app';
import { MBox, MText, MVStack } from '../../../components/Monetize';
import { getAddress } from '../../../utils/address';

interface QuoteShareContactCardProps extends BoxProps {
  label?: string;
  contact: IContactRespSchema;
  address: IAddressSchema;
  addressSource: QuoteSettingsDefaultAddressSourceEnum;
}

export const QuoteShareContactCard = ({
  label,
  contact,
  address,
  addressSource,
}: QuoteShareContactCardProps) => {
  const resolvedAddress =
    addressSource === QuoteSettingsDefaultAddressSourceEnum.ACCOUNT
      ? address
      : contact.address;
  const { cityStatePCCountry } = getAddress(resolvedAddress);

  return (
    <MBox>
      {label && (
        <Heading as="h3" fontSize="sm" fontWeight="500">
          {label}
        </Heading>
      )}
      <MVStack alignItems="flex-start" gap="0.2rem" mb="0.8rem">
        <MText lineClamp={1}>{contact.fullName}</MText>
        <MText lineClamp={1}>{contact.email}</MText>
        {resolvedAddress?.line1 && (
          <MText lineClamp={1}>{resolvedAddress.line1}</MText>
        )}
        {resolvedAddress?.line2 && (
          <MText lineClamp={1}>{resolvedAddress.line2}</MText>
        )}
        <MText lineClamp={1}>{cityStatePCCountry}</MText>
        {contact.phone && <MText lineClamp={1}>{contact.phone}</MText>}
      </MVStack>
    </MBox>
  );
};
